import * as yup from "yup";

export type SchedulePriceValidationType = yup.InferType<typeof SchedulePriceValidation>;

export const SchedulePriceValidation = yup
	.object({
		startPrice: yup.number().typeError("").required(),
		endPrice: yup.number().typeError("").required(),
		alterPriceBy: yup.number().typeError("").required(),
		cycle: yup.string().required(),

		startDate: yup.date().nullable().optional(),
		endDate: yup.date().nullable().optional(),

		startTimeHour: yup.number().min(0, "").max(12, "").typeError("").required(),
		startTimeMinute: yup.number().min(0, "").max(59, "").typeError("").required(),
		startTimeAbbreviation: yup.string().required(),

		endTimeHour: yup.number().min(0, "").max(12, "").typeError("").required(),
		endTimeMinute: yup.number().min(0, "").max(59, "").typeError("").required(),
		endTimeAbbreviation: yup.string().required(),
	})
	.test("date-range-complete", "", (v) => !!v?.startDate && !!v?.endDate);
